import { Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import isEqual from 'lodash-es/isEqual';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';

import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class CustomYearBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: 1,
      isPrevVisible: false,
      isNextVisible: true,
    };
    autoBind(this);
  }

  componentDidMount() {
    const { data } = this.props;
    if (data.length <= 5) {
      this.setState({
        isNextVisible: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (!isEqual(data, prevProps.data)) {
      this.setState({
        activeSection: 1,
        isPrevVisible: false,
        isNextVisible: data.length > 5,
      });
    }
  }

  handleDecreaseSection() {
    const { activeSection } = this.state;
    if (activeSection > 1) {
      this.setState({
        activeSection: activeSection - 1,
        isNextVisible: true,
        isPrevVisible: activeSection - 1 !== 1,
      });
    }
  }

  handleIncreaseSection() {
    const { activeSection } = this.state;
    const { data } = this.props;
    const sectionCount = Math.ceil(data.length / 5);
    if (activeSection < sectionCount) {
      this.setState({
        activeSection: activeSection + 1,
        isPrevVisible: true,
        isNextVisible: activeSection + 1 !== sectionCount,
      });
    }
  }

  renderSections() {
    const { activeSection } = this.state;
    const { data, selectedYear, onClick } = this.props;
    const sectionCount = Math.ceil(data.length / 5);

    const mainSection = [];

    for (let i = 0; i < sectionCount; i += 1) {
      const sectionBox = [];
      const startIndex = i * 5;
      const endIndex = (i * 5) + 5;
      const sectionData = data.slice(startIndex, endIndex);
      for (let j = 0; j < 5; j += 1) {
        const year = sectionData[j];
        if (year) {
          sectionBox.push((
            <div
              key={`tab_${i}_${j}`}
              className={cx('tab_item', { active: selectedYear === year })}
              onClick={() => onClick(year)}
            >
              {year}
            </div>
          ));
        } else {
          sectionBox.push((
            <div
              key={`tab_${i}_${j}`}
              className={cx('tab_item', 'blank')}
            />
          ));
        }
      }

      mainSection.push((
        <div
          key={`section_${i}`}
          className={cx('tab_sections', { active: activeSection === i + 1 })}
        >
          {sectionBox}
        </div>
      ));
    }

    return mainSection;
  }

  render() {
    const { isEsg, isIR } = this.props;
    const { isPrevVisible, isNextVisible } = this.state;
    return (
      <div className={cx('custom_year_bar', { esg: isEsg, ir: isIR })}>
        <div
          className={cx('arrow', 'left', { hidden: !isPrevVisible })}
          onClick={this.handleDecreaseSection}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <div className={Styles.year_tabs}>
          {this.renderSections()}
        </div>
        <div
          className={cx('arrow', 'right', { hidden: !isNextVisible })}
          onClick={this.handleIncreaseSection}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
      </div>
    );
  }
}

export default withComponentName(CustomYearBar);
